import { MarketWithSelections } from '@draftkings/component-builder';
import { componentConfig } from '../../config/componentConfig';
import { shouldShowScores } from '../../parser/helpers/shouldShowScores';
import { getDefaultValue } from '@draftkings/sportsbook-common-utils';

const dynamicComponentIds = [11, 12];

export const isParlayCard = (
    componentId: number,
    marketsWithSelections?: MarketWithSelections[],
    isTeamSwap?: boolean
): boolean => {
    if (componentConfig[componentId] === 'live') {
        return true;
    }

    if (dynamicComponentIds.includes(componentId) && marketsWithSelections && marketsWithSelections.length === 1) {
        const showScores = shouldShowScores({
            marketsWithSelections: getDefaultValue(marketsWithSelections, []),
            isTeamSwap: getDefaultValue(isTeamSwap, false)
        });

        return showScores;
    }

    return false;
};
